module.exports = __webpack_public_path__ + "static/img/anjun.dc1afd08.png";